import { FC } from 'react'
import { NavLink } from 'react-router-dom'
import { IOrder, IOrderItem } from '../../model/IOrder'
import Button from '../form/Button'
import Infoblock from '../infoblock/Infoblock'
import SubTitle from '../title/SubTitle'
import Title from '../title/Title'
import parseISOToString from '../../utils/parseISOToString'

const OrderShipment: FC<IOrderItem> = ({ siCarrierLink, siTrackingNum, siDate }) => (
  <div className='flex flex-col gap-4'>
    <Title>Track Shipment</Title>
    {!siCarrierLink ? (
      <>
        Your order is being processed and has not been shipped yet. We’ll send you an update when it
        has been shipped.
      </>
    ) : (
      <>
        <SubTitle>Reference Numbers</SubTitle>
        <div className='flex gap-10'>
          <Infoblock title='Track #'>{siTrackingNum}</Infoblock>
          {!!siDate && <Infoblock title='Shipping Date'>{parseISOToString(siDate)}</Infoblock>}
        </div>

        <div className=''>
          <SubTitle>Track your shipment</SubTitle>
          Clicking on the button below will open an external site to track your shipment.
        </div>

        <NavLink
          to={siCarrierLink || ''}
          target='_blank'
          className='mt-2'
        >
          <Button
            isNotFullWidth
            variant='outline'
          >
            Track Shipment
          </Button>
        </NavLink>
      </>
    )}
  </div>
)

export default OrderShipment
